<div class="row row-header">
	<div class="col">
		<h1 data-testid="SUBSYS5_PLANSETTINGS_TITLE_TXT" class="mb-5">{{ labels().PLAN_SETTINGS_COMPONENT_TITLE }}</h1>
		<tsp-plan-header [plan]="plan()!" [hasPatientLink]="true" />
	</div>
</div>

<div class="row row-contents">
	<div class="col">

		@if (isVisible()) {

		<div class="mt-5">
			<tsp-treatment-progress-bar [progress]="progress()!" (consolidationDays)="consolidationDays.set($event)"
				(isValid)="isConsolidationValid.set($event)" [isReadonly]="isReadonly()" />
		</div>
		<div class="mt-5">
			<tsp-notification-threshold [threshold]="threshold()" (thresholdChange)="threshold.set($event)"
				[isReadonly]="isReadonly()" />
		</div>

		}

		<div class="bottom-bar-save bottom-bar-save-plan">
			<button data-testid="SUBSYS5_PLANSETTINGS_CANCEL_BTN" type="button" class="btn btn-secondary-outline"
				(click)="cancel()">
				{{ labels().PLAN_SETTINGS_COMPONENT_CANCEL_BUTTON }}
			</button>
			@if (isRevokeVisible()) {
			<button data-testid="SUBSYS5_PLANSETTINGS_REVOKE_BTN" type="button" class="btn btn-primary btn-red"
				(click)="openRevokeModal()">
				{{ labels().PLAN_SETTINGS_COMPONENT_REVOKE_BUTTON }}
			</button>
			}
			@if (!isReadonly()) {
			<button data-testid="SUBSYS5_PLANSETTINGS_UPDATE_BTN" type="button" class="btn btn-primary ms-3"
				(click)="update()" [disabled]="isUpdateDisabled()">
				{{ labels().PLAN_SETTINGS_COMPONENT_UPDATE_BUTTON }}
			</button>
			}
		</div>

	</div>
</div>